import React, { Component } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Dreams from "./components/dreams";
 
 
import DreamForm from "./components/dreamForm";
import DreamsSearch from "./components/dreamsSearch";
 
import NotFound from "./components/notFound";
import AllDreams from "./components/allDreams";
import Report from "./components/report";
import LoginForm from "./components/loginForm";
import Keywords from "./components/keywords";
 
import Logout from "./components/logout";
import ProtectedRoute from "./components/common/protectedRoute";
import auth from "./services/authService";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import 'react-quill/dist/quill.snow.css';

import AdibApp from "./components/adib";
import GPTDreams from "./components/gptdreams";
import BackToTop from "./components/common/backToTop";
// import firebase from 'firebase/app';
// var config = {
//   apiKey: "AIzaSyBLzntLesEjSnIo_TJCCBw3onmRs-MdFW4",
//   authDomain: "smscapp.firebaseapp.com",
//   databaseURL: "https://smscapp.firebaseio.com",
//   projectId: "smscapp",
//   storageBucket: "",
//   messagingSenderId: "531660843905"
// };
class App extends Component {
  state = {};

  componentDidMount() {
    //  firebase.initializeApp(config);
    const user = auth.getCurrentUser();
    this.setState({ user });
    ////console.log(user);
  }
  /* componentWillMount(){
  firebase.initializeApp(config);
} */

  render() {
    const { user } = this.state;

    return (
      <React.Fragment>
        <ToastContainer />

        <main className="container-fluid app-shell">
          <Switch>
          
            <Route path="/login" component={LoginForm} />
            <Route path="/logout" component={Logout} />
            <ProtectedRoute path="/dreams/:id" component={DreamForm} />
            {
              <ProtectedRoute
                path="/ddreams"
                render={props => <Dreams {...props} user={user} />}
              />
            }
               {
              <ProtectedRoute
                path="/Keywords"
                render={props => <Keywords {...props} user={user} />}
              />
            }
            {
              <ProtectedRoute
                path="/alldreams/:mob"
                render={props => <AllDreams {...props} user={user} />}
              />
            }
            {user && (user.startsWith('adib') ||
              user.startsWith('mona') ||
              user.startsWith('mohannad')) &&
              <ProtectedRoute
                path="/AdibApp"
                render={props => <AdibApp {...props} user={user} />}
              />
            }
   {
              <ProtectedRoute
                path="/alldreams"
                render={props => <AllDreams {...props} user={user} />}
              />
            }
             {
              <ProtectedRoute
                path="/dreamsSearch"
                render={props => <DreamsSearch {...props} user={user} />}
              />
            }
{
              <ProtectedRoute
                path="/report"
                render={props => <Report {...props} user={user} />}
              />
            }

         
              <ProtectedRoute
                path="/gpt"
                render={props => <GPTDreams {...props} user={user} />}
              />
         
          
 
            <Route path="/not-found" component={NotFound} />
            <Redirect from="/" exact to="/login" />
            <Redirect to="/not-found" />
          </Switch>
        </main>
        <BackToTop />
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js